/* lmm-pdp-inline.js — Energielabel-Modal, Lichtfarben-Slider (Raumvorschau),
   Ersparnis-Rechner (MwSt./CO2), Kompatibilitäts-Check v2, Zwischensumme & VPE-Stepper.
   Kanonische Produktivdatei im Theme (inkl. VPE-Mengenlogik und Warenkorb-Abgleich);
   NICHT mehr durch das historische Mock-Skript theme/extract_index3_assets.py überschreiben. */

(function () {
  'use strict';

  /* ---- Energielabel-Modal: öffnen via F-Badge (Bild) oder
     "Energieklasse F"-Chip; schließen via Button, Backdrop-Klick und ESC;
     Fokus geht beim Öffnen auf den Schließen-Button und beim Schließen
     zurück zum Auslöser. ---- */
  var modal = document.getElementById('lmm-energy-modal');
  if (modal) {
    var lastTrigger = null;
    var onKey = function (e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      /* Fokus-Trap: Tab/Shift+Tab bleiben im Dialog (Hintergrund nicht fokussierbar). */
      var f = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    var openModal = function (trigger) {
      lastTrigger = trigger;
      modal.hidden = false;
      var labelImg = modal.querySelector('[data-lmm-elabel-img]');
      if (labelImg && !labelImg.getAttribute('src')) {
        var labelSrc = labelImg.getAttribute('data-src');
        if (labelSrc) {
          labelImg.addEventListener('error', function () {
            var official = labelImg.closest('.lmm-elabel__official');
            var fallback = modal.querySelector('[data-lmm-elabel-fallback]');
            if (official) official.hidden = true;
            if (fallback) fallback.hidden = false;
          }, { once: true });
          labelImg.setAttribute('src', labelSrc);
        }
      }
      var closeBtn = modal.querySelector('.lmm-modal__close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    };
    var closeModal = function () {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    };
    document.querySelectorAll('[data-lmm-energy-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(el);
      });
    });
    modal.querySelectorAll('[data-lmm-energy-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
  }

  /* ---- Lichtfarben-Vorschau: Slider + Presets steuern Kelvin-Wert,
     Beschreibungszeile, aktive Preset-Markierung und die Lichtstimmung der
     Raumvorschau (reine UI-Orientierung, kein Lichtlabor). ---- */
  var kelvin = document.querySelector('[data-lmm-kelvin]');
  if (kelvin) {
    var kRange = kelvin.querySelector('[data-lmm-kelvin-range]');
    var kOut = kelvin.querySelector('[data-lmm-kelvin-out]');
    var kDesc = kelvin.querySelector('[data-lmm-kelvin-desc]');
    var kPresets = Array.prototype.slice.call(kelvin.querySelectorAll('[data-lmm-kelvin-preset]'));

    /* Farb-Stuetzstellen fuer die Lichtstimmung (Interpolation).
       Review 2026-06-12 #7: bewusst entschaerft — der Raum wird zusaetzlich
       stark Richtung neutraler Wandfarbe gemischt (Lichtstimmung statt
       Farbfilter); die Lichtkegel tragen die deutlichere Faerbung. */
    var K_STOPS = [
      [2200, [255, 183, 110]],
      [3000, [255, 219, 170]],
      [4000, [253, 245, 234]],
      [5000, [242, 246, 252]],
      [6500, [214, 228, 250]]
    ];
    var K_WALL = [246, 244, 241]; /* neutraler Wandton */
    var mixRgb = function (c, target, t) {
      return c.map(function (v, i) { return Math.round(v + (target[i] - v) * t); });
    };
    /* Kurztexte ohne Einsatzversprechen (Review 2026-06-12 #6, Punkt 4) */
    var initialKelvin = kRange ? (parseInt(kRange.value, 10) || 0) : 0;
    var K_TEXTS = [
      { k: 2700, text: 'Warmweiß (827) wirkt besonders warm und gemütlich.' },
      { k: 3000, text: 'Warmweiß (830) wirkt wohnlich und angenehm.' },
      { k: 4000, text: 'Neutralweiß / kaltweiß (840) wirkt neutral und sachlich — häufig in Büro- und Arbeitsbereichen.' },
      { k: 6500, text: 'Tageslichtweiß (865) wirkt sachlich, hell und tageslichtnah.' }
    ];

    var kelvinColor = function (k) {
      var i = 0;
      while (i < K_STOPS.length - 2 && k > K_STOPS[i + 1][0]) i++;
      var a = K_STOPS[i], b = K_STOPS[i + 1];
      var t = Math.min(1, Math.max(0, (k - a[0]) / (b[0] - a[0])));
      return a[1].map(function (v, j) { return Math.round(v + (b[1][j] - v) * t); });
    };

    var setKelvin = function (k) {
      /* Clamp NICHT hart auf 2200-6500, sondern auf den (ggf. pro Artikel erweiterten)
         Slider-Bereich — damit der exakte Kelvinwert auch bei Sonderwerten (z. B. 1.800 K,
         8.000 K) sichtbar bleibt und nicht verfaelscht wird. */
      var kMin = parseInt(kRange.min, 10) || 2200;
      var kMax = parseInt(kRange.max, 10) || 6500;
      k = Math.min(kMax, Math.max(kMin, Math.round(k)));
      if (String(kRange.value) !== String(k)) kRange.value = k;
      kOut.textContent = k.toLocaleString('de-DE') + ' K';
      var c = kelvinColor(k);
      /* Raum: nur dezente Stimmung (70 % Richtung Wandton) */
      kelvin.style.setProperty('--lmm-kelvin-col', 'rgb(' + mixRgb(c, K_WALL, 0.7).join(',') + ')');
      /* Lichtkegel: deutlichere Faerbung, halbtransparent */
      kelvin.style.setProperty('--lmm-kelvin-glow', 'rgba(' + mixRgb(c, [255, 255, 255], 0.25).join(',') + ',0.6)');
      var nearest = K_TEXTS.reduce(function (best, p) {
        return Math.abs(p.k - k) < Math.abs(best.k - k) ? p : best;
      });
      if (kDesc) kDesc.textContent = nearest.text + (initialKelvin && Math.abs(k - initialKelvin) <= 100 ? ' — die Lichtfarbe dieses Artikels.' : '');
      kPresets.forEach(function (btn) {
        /* Aktiv-Markierung nur bei EXAKTEM Treffer (nicht „naechster" Standardwert) — sonst
           wuerde bei einem Sonderwert-Artikel (z. B. 2.200 K) faelschlich ein Standard-Preset
           (2.700 K) als aktiv markiert. Beschreibung (kDesc) nutzt weiter den naechsten Text. */
        var active = parseInt(btn.dataset.lmmKelvinPreset, 10) === k;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    ['input', 'change'].forEach(function (evt) {
      kRange.addEventListener(evt, function () { setKelvin(parseInt(kRange.value, 10)); });
    });
    kPresets.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setKelvin(parseInt(btn.dataset.lmmKelvinPreset, 10));
      });
    });
    setKelvin(parseInt(kRange.value, 10) || 3000);
  }

  /* ---- Ersparnis-Rechner mit MwSt.-Ansicht (Review 2026-06-12 #10) ----
     Uebernimmt die komplette Rechnung von lmm-pdp-seo.js (dort ueber das
     umbenannte Container-Attribut sauber abgehaengt). Formeln und Konstanten
     unveraendert: 38 W − 11,6 W, 30.000 h Bemessungslebensdauer, Beispielpreis
     5,75 € brutto je Roehre. Die MwSt.-Ansicht steuert die KOMPLETTE
     Darstellung: Geld-Kacheln zeigen nur den aktiven Modus.
     Intern wird der exakte Brutto-Tarif gefuehrt (tariffGross); das Feld
     zeigt die auf 2 Stellen gerundete Ansicht ("ca."), damit beim Umschalten
     26,98 € inkl. exakt zu 22,67 € exkl. wird (Faktor 1,19, ohne
     Rundungsdrift). vatRate ist eine Mock-Konstante — kommt spaeter aus
     Shopify/Steuerlogik. */
  var calc = document.querySelector('[data-lmm-calc-vat]');
  if (calc) {
    var attrF = function (name, def) { var v = parseFloat(calc.getAttribute(name)); return isFinite(v) ? v : def; };
    var vatRate = attrF('data-lmm-vat-rate', 19) / 100; /* aus Produktdaten/Settings; Fallback 19 % */
    var VAT_F = 1 + vatRate;
    /* TUEV-02 Nachlauf (2026-08-17): PRODUKT-MwSt. ist nicht die STROM-MwSt.
       VAT_F bleibt der deutsche Strompreissatz. Der Shop-Preis nutzt den Satz des
       Storefront-Marktes (Liquid: snippets/lmm-vat-rate.liquid). Fehlt das Attribut,
       gilt exakt das bisherige Verhalten - keine Verschlechterung. */
    var shopVatRate = attrF('data-lmm-shop-vat-rate', vatRate * 100) / 100;
    var SHOP_VAT_F = 1 + shopVatRate;
    var OLD_W = attrF('data-lmm-old-w', 0);               /* ersetzte Leistung (mf.specs.replaces_wattage); Fallback 0 statt Beispielwert */
    var NEW_W = attrF('data-lmm-new-w', 0);               /* Leistung dieses Artikels (mf.specs.wattage) */
    var LIFETIME_H = attrF('data-lmm-lifetime-h', 0);     /* Bemessungslebensdauer (mf.specs.lifetime_hours) */
    var UNIT_PRICE_GROSS = attrF('data-lmm-unit-gross', 0); /* echter Variant-Preis (brutto) */
    /* Mock-Faktor: 0,344 kg CO₂/kWh nach deutschem Strommix 2025; später
       zentral konfigurierbar bzw. aus Nachhaltigkeits-/Content-Konfiguration
       beziehen. */
    var co2FactorKgPerKwh = 0.344;

    var elTubes = calc.querySelector('[data-lmm-calc-tubes]');
    var elHours = calc.querySelector('[data-lmm-calc-hours]');
    var elHoursOut = calc.querySelector('[data-lmm-calc-hours-out]');
    var elPrice = calc.querySelector('[data-lmm-calc-price]');
    var elPriceLabel = calc.querySelector('[data-lmm-price-label]');
    var elEquiv = calc.querySelector('[data-lmm-vat-equiv]');
    var vatBtns = Array.prototype.slice.call(calc.querySelectorAll('[data-lmm-vat-mode]'));
    var vatTags = Array.prototype.slice.call(calc.querySelectorAll('[data-lmm-vat-tag]'));
    var outKwh = calc.querySelector('[data-lmm-out-kwh]');
    var outCo2 = calc.querySelector('[data-lmm-out-co2]');
    var outEurYear = calc.querySelector('[data-lmm-out-eur-year]');
    var outEurLife = calc.querySelector('[data-lmm-out-eur-life]');
    var outPayback = calc.querySelector('[data-lmm-out-payback]');
    var outPaybackBasis = calc.querySelector('[data-lmm-out-payback-basis]');

    var vatMode = 'incl'; /* Standard im Mock: Ansicht inkl. MwSt. */
    var tariffGross = 0.35; /* kanonischer Brutto-Tarif (exakt); Feld = Ansicht */

    var fmtInt = function (n) {
      return Math.round(n).toLocaleString('de-DE');
    };
    var fmtEur = function (n) {
      return n.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €';
    };

    /* Tippt der Nutzer einen Preis, gilt der eingegebene Wert exakt in der
       aktiven Ansicht und wird zum neuen kanonischen Tarif. */
    var syncTariffFromField = function () {
      var v = parseFloat(String(elPrice.value).replace(',', '.'));
      if (!isFinite(v)) return; /* leeres Feld: letzten Tarif behalten */
      v = Math.max(0.01, Math.min(2, v));
      tariffGross = vatMode === 'incl' ? v : v * VAT_F;
    };

    var recalcVat = function () {
      var tubes = Math.max(1, Math.min(200, parseInt(elTubes.value, 10) || 1));
      var hours = Math.max(1, Math.min(24, parseFloat(elHours.value) || 8));
      /* Preis in der aktiven Ansicht (exakt, aus dem kanonischen Tarif) */
      var price = vatMode === 'incl' ? tariffGross : tariffGross / VAT_F;
      var unitPrice = (vatMode === 'incl' || shopVatRate === 0)
        ? UNIT_PRICE_GROSS
        : UNIT_PRICE_GROSS / SHOP_VAT_F;
      var tag = vatMode === 'incl' ? 'inkl. MwSt.' : 'exkl. MwSt.';
      /* Beschriftung des PRODUKT-Preises folgt der Produkt-MwSt.: bei 0 % (CH, NO)
         ist der Betrag in beiden Ansichten derselbe und traegt 'ohne MwSt.'. */
      var shopTag = shopVatRate === 0 ? 'ohne MwSt.' : tag;

      var diffKw = (OLD_W - NEW_W) / 1000; /* 0,0264 kW */
      var kwhYear = diffKw * hours * 365 * tubes;
      var eurYear = kwhYear * price;
      var eurLife = diffKw * LIFETIME_H * price * tubes;
      /* Monatszahl: bei 19 % Produkt-MwSt. (DE) kuerzt sich der Faktor zwischen
         Preisbasis und Jahresersparnis heraus, die Ansicht aendert sie also nicht.
         Weichen Produkt- und Stromsatz voneinander ab (AT 20 %, CH/NO 0 %), tut sie
         das in der Netto-Ansicht zu Recht - dort werden zwei verschieden besteuerte
         Groessen verglichen. */
      var paybackMonths = eurYear > 0 ? (unitPrice * tubes) / eurYear * 12 : null;

      /* CO2: haengt nur vom eingesparten Strom ab — Strompreis und
         MwSt.-Ansicht beeinflussen die Schaetzung bewusst nicht. */
      var co2SavingKgPerYear = kwhYear * co2FactorKgPerKwh;

      if (elHoursOut) elHoursOut.textContent = hours.toLocaleString('de-DE') + ' h/Tag';
      if (outKwh) outKwh.textContent = fmtInt(kwhYear) + ' kWh';
      if (outCo2) {
        outCo2.textContent = co2SavingKgPerYear >= 1000
          ? '≈ ' + (co2SavingKgPerYear / 1000).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' t CO₂'
          : '≈ ' + fmtInt(co2SavingKgPerYear) + ' kg CO₂';
      }
      if (outEurYear) outEurYear.textContent = fmtEur(eurYear);
      if (outEurLife) outEurLife.textContent = fmtEur(eurLife);
      if (outPayback) {
        outPayback.textContent = paybackMonths === null
          ? '—'
          : (paybackMonths < 1
            ? 'unter 1 Monat'
            : 'ca. ' + fmtInt(paybackMonths) + (Math.round(paybackMonths) === 1 ? ' Monat' : ' Monate'));
      }
      if (outPaybackBasis) outPaybackBasis.textContent = 'auf Basis von ' + fmtEur(unitPrice) + ' ' + shopTag;
      vatTags.forEach(function (t) { t.textContent = tag; });
      if (elPriceLabel) {
        elPriceLabel.textContent = vatMode === 'incl' ? 'Strompreis inkl. MwSt.' : 'Strompreis exkl. MwSt.';
      }
      if (elEquiv) {
        elEquiv.textContent = vatMode === 'incl'
          ? 'entspricht ca. ' + fmtEur(tariffGross / VAT_F) + '/kWh exkl. MwSt.'
          : 'entspricht ca. ' + fmtEur(tariffGross) + '/kWh inkl. MwSt.';
      }
    };

    /* Umschalten: Feld zeigt den Tarif in der neuen Ansicht (gerundet,
       "ca."); gerechnet wird mit dem exakten kanonischen Tarif. */
    var setVatMode = function (mode) {
      if (mode === vatMode) return;
      vatMode = mode;
      var shown = mode === 'incl' ? tariffGross : tariffGross / VAT_F;
      elPrice.value = (Math.round(shown * 100) / 100).toFixed(2);
      vatBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.lmmVatMode === mode ? 'true' : 'false');
      });
      recalcVat();
    };

    ['input', 'change'].forEach(function (evt) {
      elPrice.addEventListener(evt, syncTariffFromField);
      calc.addEventListener(evt, recalcVat);
    });
    vatBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setVatMode(btn.dataset.lmmVatMode); });
    });
    recalcVat();
  }

  /* ---- Kompatibilitäts-Check v2 — kompakt (Review 2026-06-13) ----
     Bewertung + schlanker Tab-Hilfebereich, vollständig inline (der ältere
     Handler in lmm-pdp-seo.js hängt am alten Attribut data-lmm-check und ist
     damit inaktiv). Bewertet NUR die Nutzerangaben gegen die Herstellerdaten
     DIESES Artikels.

     PROFIL dieser PDP: tube_t8_g13_kvg (röhrenspezifisch: G13 · T8 · 1.050 mm ·
     ersetzt 38 W · KVG/VVG bzw. 220–240 V AC). Dieser Check ist NICHT universell.
     Andere Produkttypen brauchen eigene Fragen/Hilfen/Pass-Regeln, z. B.:
     lamp_e27, lamp_e14, spot_gu10, linear_r7s, compact_fluorescent. Für die echte
     Migration muss der Check je Produkttyp datengetrieben aus den Produktdaten
     erzeugt werden — hier bewusst nur EIN Profil fest verdrahtet, keine Engine.
     Bei „Weiß ich nicht" wird der passende Hilfe-Tab geöffnet und hervorgehoben.
     Keine Elektroberatung, keine Umbauanleitung. */
  var check2 = document.querySelector('[data-lmm-check-v2]');
  if (check2) {
    var cWrap = check2.closest('[data-lmm-compat-profile]');
    var cAttr = function (name, def) { var v = cWrap && cWrap.getAttribute(name); return (v === null || v === undefined || v === '') ? def : v; };
    /* Produktprofil datengetrieben über die Container-Attribute (im Theme aus
       mf.specs.*): erforderliche Betriebsart + kundensichtbare Labels für die
       Einschätzung. Fallback = T8/G13/KVG (dieser Mock-Artikel). */
    var cReqBallast = cAttr('data-lmm-req-ballast', 'kvg');
    var cLblSocket = cAttr('data-lmm-socket-label', 'G13');
    var cLblForm = cAttr('data-lmm-form-label', '');
    var cLblLength = cAttr('data-lmm-length-label', '1.050 mm');
    var cLblReplaces = cAttr('data-lmm-replaces-label', '');
    var cLblBallast = cAttr('data-lmm-ballast-label', 'KVG/VVG');
    var cBallastDeny = cAttr('data-lmm-ballast-deny', 'laut Hersteller für eine andere Betriebsart vorgesehen');
    /* Zusatzhinweis im "passt"-Verdikt, datengetrieben (Theme: nur LED+KVG = LED-Starter;
       Leuchtstoffröhren liefern leer = kein Starter-Hinweis). Default leer. */
    var cGoodNote = cAttr('data-lmm-good-note', '');
    var cVerdict = check2.querySelector('[data-lmm-verdict]');
    var cHelp = {
      socket: document.querySelector('[data-lmm-help="socket"]'),
      length: document.querySelector('[data-lmm-help="length"]'),
      ballast: document.querySelector('[data-lmm-help="ballast"]')
    };
    var cTabs = {};
    Array.prototype.forEach.call(document.querySelectorAll('.lmm-helptab'), function (t) {
      cTabs[t.getAttribute('data-lmm-tab')] = t;
    });
    var cTabOrder = ['socket', 'length', 'ballast'];
    var cReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Tab aktivieren — nur die gewählte Kurz-Erklärung ist sichtbar */
    var cActivate = function (key, reveal) {
      cTabOrder.forEach(function (k) {
        var on = k === key, tab = cTabs[k], panel = cHelp[k];
        if (tab) {
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        }
        if (panel) { panel.classList.toggle('is-active', on); panel.hidden = !on; }
      });
      if (reveal && cHelp[key]) {
        cHelp[key].scrollIntoView({ block: 'nearest', behavior: cReduceMotion ? 'auto' : 'smooth' });
      }
    };
    /* Klick + Pfeiltasten/Home/End auf der Tableiste (Accessibility) */
    cTabOrder.forEach(function (k) {
      if (cTabs[k]) cTabs[k].addEventListener('click', function () { cActivate(k); cTabs[k].focus(); });
    });
    var cTablist = check2.parentNode.querySelector('.lmm-helptabs');
    if (cTablist) {
      cTablist.addEventListener('keydown', function (e) {
        var active = document.activeElement;
        var cur = (active && active.getAttribute) ? cTabOrder.indexOf(active.getAttribute('data-lmm-tab')) : -1;
        if (cur < 0) return;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (cur + 1) % cTabOrder.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (cur - 1 + cTabOrder.length) % cTabOrder.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = cTabOrder.length - 1;
        if (next === null) return;
        e.preventDefault();
        cActivate(cTabOrder[next]);
        cTabs[cTabOrder[next]].focus();
      });
    }

    var cIcon = {
      good: '<svg class="lmm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>',
      warn: '<svg class="lmm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5h.01"/></svg>',
      bad: '<svg class="lmm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/></svg>'
    };
    var cGet = function (name) {
      var el = check2.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    };
    var cRender = function (cls, icon, title, lines) {
      cVerdict.className = 'lmm-verdict lmm-verdict--' + cls;
      cVerdict.innerHTML = icon + '<div><strong>' + title + '</strong>' +
        lines.map(function (l) { return '<p>' + l + '</p>'; }).join('') + '</div>';
    };
    /* Hervorhebung der offenen Frage: Tab (roter Punkt) + Panel (Tönung/Pille) */
    var cFlag = function (key, on) {
      if (cHelp[key]) cHelp[key].classList.toggle('is-flag', on);
      if (cTabs[key]) cTabs[key].classList.toggle('is-flag', on);
    };

    var cEvaluate = function () {
      var socket = cGet('lmm-q-socket');
      var length = cGet('lmm-q-length');
      var ballast = cGet('lmm-q-ballast');

      /* "Weiß ich nicht" hebt die passende Hilfekarte hervor */
      cFlag('socket', socket === 'unsicher');
      cFlag('length', length === 'unsicher');
      cFlag('ballast', ballast === 'unsicher');

      if (!socket || !length || !ballast) {
        cVerdict.className = 'lmm-verdict lmm-verdict--idle';
        cVerdict.innerHTML = '<div><strong>Noch nicht alle Fragen beantwortet</strong>' +
          '<p>Bitte Sockel, Länge und Betriebsart angeben — die Einschätzung erscheint hier.</p></div>';
        return;
      }

      /* 1) harte Abweichung: passt wahrscheinlich nicht (Betriebsart datengetrieben) */
      var ballastWrong = ballast && ballast !== 'unsicher' && cReqBallast !== 'uni' && ballast !== cReqBallast;
      if (socket === 'nein' || length === 'nein' || ballastWrong) {
        var why = [];
        if (socket === 'nein') why.push('Sockel: dieser Artikel hat ' + cLblSocket + (cLblForm ? ' (' + cLblForm + ')' : '') + '.');
        if (length === 'nein') why.push('Länge: dieser Artikel ist ' + cLblLength + (cLblReplaces ? ' (Ersatz für ' + cLblReplaces + ')' : '') + '.');
        if (ballastWrong) why.push('Betriebsart: ' + cBallastDeny + '.');
        cRender('bad', cIcon.bad,
          'Diese Variante passt wahrscheinlich nicht. Bitte Sockel, Länge oder Betriebsart prüfen.',
          [why.join(' ')]);
        return;
      }

      /* 2) Unsicherheit: keine sichere Einschätzung */
      if (socket === 'unsicher' || length === 'unsicher' || ballast === 'unsicher') {
        cRender('warn', cIcon.warn,
          'Bitte prüfen oder Kundenservice fragen – keine sichere Einschätzung möglich.',
          ['Die hervorgehobene Erklärung hilft beim offenen Punkt.']);
        return;
      }

      /* 3) alles passt */
      cRender('good', cIcon.good,
        'Sieht passend aus – bitte Hinweise beachten.',
        [cLblSocket + '-Sockel, ca. ' + cLblLength + ' Baulänge und Betrieb am ' + cLblBallast + ' entsprechen den Herstellerdaten dieses Artikels.' + (cGoodNote ? ' ' + cGoodNote : '')]);
    };

    var cMap = { 'lmm-q-socket': 'socket', 'lmm-q-length': 'length', 'lmm-q-ballast': 'ballast' };
    check2.addEventListener('change', function (e) {
      cEvaluate();
      /* JEDER Antwort-Klick aktiviert rechts den passenden Tab (auch ein Wechsel
         zurück, z. B. Klick auf Frage 1, während gerade "Länge" aktiv ist). Bei
         "Weiß ich nicht" wird die Hilfe zusätzlich sanft herangescrollt (relevant
         auf Mobile, wo die Box unter den Fragen liegt). */
      var key = e.target && cMap[e.target.name];
      if (key) {
        cActivate(key, cGet(e.target.name) === 'unsicher');
      }
    });
    cEvaluate();
  }

  var input = document.getElementById('lmm-qty-input');
  var subtotalEl = document.querySelector('[data-lmm-subtotal]');
  var gross = document.querySelector('[data-lmm-subtotal-gross]');
  var net = document.querySelector('[data-lmm-subtotal-net]');
  if (!input || !gross || !net) return;

  /* Stückpreis + MwSt.-Satz aus den Produktdaten (Theme: variant.price /
     section.settings.vat_rate); Fallback = Mock-Werte dieses Artikels. */
  var sAttr = function (name, def) { var v = subtotalEl ? parseFloat(subtotalEl.getAttribute(name)) : NaN; return isFinite(v) ? v : def; };
  var UNIT_GROSS = sAttr('data-lmm-unit-gross', 0);
  if (!(UNIT_GROSS > 0)) return;
  var VAT = 1 + sAttr('data-lmm-vat-rate', 19) / 100;

  var eur = function (n) {
    return n.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  };

  var vpeBox = document.querySelector('[data-lmm-vpe-box]');
  var vpeQty = vpeBox ? (parseInt(vpeBox.getAttribute('data-vpe-qty'), 10) || 0) : 0;
  var vpeSku = vpeBox ? String(vpeBox.getAttribute('data-vpe-sku') || '').trim().toUpperCase() : '';
  var getInCartQty = function () {
    if (!vpeBox) return 0;
    var n = parseInt(vpeBox.getAttribute('data-in-cart-qty'), 10);
    return (isFinite(n) && n >= 0) ? n : 0;
  };
  var syncInCartQtyFromDrawer = function () {
    if (!vpeBox || !vpeSku) return;
    var panel = document.querySelector('[data-lmm-cd] .lmm-cd__panel');
    if (!panel) return;
    var lines = panel.querySelectorAll('.lmm-cd__line');
    var sumQty = 0;
    for (var i = 0; i < lines.length; i++) {
      var skuEl = lines[i].querySelector('.lmm-cd__sku');
      var skuTxt = skuEl ? skuEl.textContent.replace(/^Art\.-Nr\.:\s*/i, '').trim().toUpperCase() : '';
      if (skuTxt === vpeSku) {
        var qIn = lines[i].querySelector('[data-lmm-cd-qtyinput]');
        var qVal = qIn ? parseInt(qIn.getAttribute('data-confirmed') || qIn.value, 10) : 0;
        if (isFinite(qVal) && qVal > 0) sumQty += qVal;
      }
    }
    vpeBox.setAttribute('data-in-cart-qty', String(sumQty));
    var stEl = panel.querySelector('[data-lmm-vpe-state]') || panel;
    var slotsAttr = stEl.getAttribute('data-lmm-max-vpe-slots');
    if (slotsAttr !== null && slotsAttr !== '') {
      vpeBox.setAttribute('data-max-vpe-slots', slotsAttr);
    }
    var rankedAttr = stEl.getAttribute('data-lmm-vpe-ranked');
    if (rankedAttr !== null) {
      var myCode = 'VPE-' + vpeSku;
      var seenCodes = {};
      var otherList = [];
      var parts = rankedAttr ? rankedAttr.split(',') : [];
      for (var j = 0; j < parts.length; j++) {
        var segs = parts[j].split('|');
        if (segs.length === 2) {
          var cSav = parseInt(segs[0], 10) || 0;
          var cCode = segs[1].trim().toUpperCase();
          if (cCode && cCode !== myCode && !seenCodes[cCode] && cSav > 0) {
            seenCodes[cCode] = true;
            otherList.push(cSav + '|' + cCode);
          }
        }
      }
      vpeBox.setAttribute('data-other-vpe-savings', otherList.join(','));
    }
  };
  var unitCentsAttr = vpeBox ? parseInt(vpeBox.getAttribute('data-unit-cents'), 10) : NaN;
  var unitCents = isFinite(unitCentsAttr) ? unitCentsAttr : Math.round(UNIT_GROSS * 100);
  var vpeDiscCentsAttr = vpeBox ? parseInt(vpeBox.getAttribute('data-vpe-disc-cents'), 10) : NaN;
  var vpeDiscCents = isFinite(vpeDiscCentsAttr) ? vpeDiscCentsAttr : Math.max(1, Math.floor((unitCents + 50) / 100));
  var vpeUnitCents = unitCents - vpeDiscCents;
  var vpeUnitGross = vpeUnitCents / 100.0;
  var vpeCountEl = vpeBox ? vpeBox.querySelector('[data-lmm-vpe-count]') : null;
  var vpePiecesEl = vpeBox ? vpeBox.querySelector('[data-lmm-vpe-pieces]') : null;
  var vpeSubEl = vpeBox ? vpeBox.querySelector('[data-lmm-vpe-sub]') : null;
  var vpeBadgeEl = vpeBox ? vpeBox.querySelector('[data-lmm-vpe-badge]') : null;
  var vpeMinusBtn = vpeBox ? vpeBox.querySelector('[data-lmm-vpe-step="-1"]') : null;
  var vpePlusBtn = vpeBox ? vpeBox.querySelector('[data-lmm-vpe-step="1"]') : null;

  var parseStrictQty = function (val) {
    var s = String(val === undefined || val === null ? '' : val).trim();
    if (!s) return 1;
    var num = Number(s.replace(',', '.'));
    if (isFinite(num) && num >= 1) return Math.floor(num);
    var clean = s.replace(/[^0-9]/g, '');
    var n = parseInt(clean, 10);
    return (isFinite(n) && n >= 1) ? n : 1;
  };

  var hasAvailableVpeSlot = function (effQty) {
    if (!vpeBox) return true;
    var maxSlotsAttr = parseInt(vpeBox.getAttribute('data-max-vpe-slots'), 10);
    var maxSlots = isFinite(maxSlotsAttr) ? maxSlotsAttr : 5;
    if (maxSlots <= 0) return false;
    var otherRaw = String(vpeBox.getAttribute('data-other-vpe-savings') || '').trim();
    if (!otherRaw) return true;
    var otherEntries = otherRaw.split(',').map(function (s) {
      var segs = String(s || '').split('|');
      var sav = parseInt(segs[0], 10) || 0;
      var code = (segs[1] || '').trim().toUpperCase();
      return { sav: sav, code: code };
    }).filter(function (e) { return e.sav > 0; });
    otherEntries.sort(function (a, b) {
      if (b.sav !== a.sav) return b.sav - a.sav;
      return b.code > a.code ? 1 : (b.code < a.code ? -1 : 0);
    });
    if (otherEntries.length < maxSlots) return true;
    var nth = otherEntries[maxSlots - 1];
    var mySavingCents = vpeDiscCents * effQty;
    var myCode = vpeSku ? ('VPE-' + vpeSku) : '';
    if (mySavingCents !== nth.sav) return mySavingCents > nth.sav;
    if (myCode && nth.code) return myCode > nth.code;
    return false;
  };

  var render = function () {
    var qty = parseStrictQty(input.value);
    var inCartQty = getInCartQty();
    var effQty = inCartQty + qty;
    var isMultiple = vpeQty >= 10 && effQty >= vpeQty && (effQty % vpeQty === 0);
    var slotAvailable = isMultiple ? hasAvailableVpeSlot(effQty) : true;
    var isVpe = isMultiple && slotAvailable;
    var isSlotCapped = isMultiple && !slotAvailable;
    var isPartialNonVpe = vpeQty >= 10 && (effQty > 1 || inCartQty > 0) && !isMultiple;
    var fullCartons = vpeQty >= 10 ? Math.floor(effQty / vpeQty) : 0;
    var remPieces = vpeQty >= 10 ? (effQty % vpeQty) : effQty;
    var cartons = isMultiple ? fullCartons : 0;
    var finalLineCents = isVpe ? (vpeUnitCents * qty) : (unitCents * qty);
    var discLineCents = isVpe ? (vpeDiscCents * effQty) : 0;
    var sum = finalLineCents / 100.0;
    if (vpeBox) {
      vpeBox.classList.toggle('is-vpe-active', isVpe);
      vpeBox.classList.toggle('is-active', isVpe);
      vpeBox.classList.toggle('is-vpe-partial', isPartialNonVpe || isSlotCapped);
      if (vpeCountEl) {
        if (isMultiple) {
          vpeCountEl.textContent = cartons + ' VPE';
        } else if (fullCartons > 0) {
          vpeCountEl.textContent = fullCartons + ' VPE + ' + remPieces;
        } else {
          vpeCountEl.textContent = '0 VPE';
        }
      }
      if (vpePiecesEl) {
        if (isMultiple) {
          vpePiecesEl.textContent = inCartQty > 0 ? ('= ' + effQty + ' St. inkl. WK') : ('= ' + qty + ' St.');
        } else if (fullCartons > 0) {
          vpePiecesEl.textContent = '(' + effQty + ' St. gesamt)';
        } else {
          vpePiecesEl.textContent = 'je ' + vpeQty + ' St.';
        }
      }
      if (vpeMinusBtn) {
        vpeMinusBtn.disabled = (qty <= 1);
      }
      if (vpeBadgeEl) {
        if (isVpe) {
          vpeBadgeEl.innerHTML = '&#10003; 1&nbsp;% VPE-Rabatt (' + cartons + '&nbsp;VPE)';
        } else if (isSlotCapped) {
          vpeBadgeEl.innerHTML = 'Max. 5 Rabattcodes im Warenkorb aktiv';
        } else if (isPartialNonVpe) {
          vpeBadgeEl.innerHTML = 'Kein VPE-Rabatt (' + effQty + '&nbsp;St. &ne; volle VPE)';
        } else {
          vpeBadgeEl.innerHTML = '1&nbsp;% VPE-Rabatt (nur bei vollen VPE)';
        }
      }
      if (vpeSubEl) {
        var cartNotePrefix = inCartQty > 0 ? ('Bereits ' + inCartQty + '&nbsp;St. im Warenkorb &middot; ') : '';
        if (isVpe) {
          var activeSave = discLineCents / 100.0;
          vpeSubEl.innerHTML = cartNotePrefix + '<strong>' + cartons + '&nbsp;VPE (' + effQty + '&nbsp;St.): ' + eur(vpeUnitGross) + '/St.</strong> <small>statt ' + eur(UNIT_GROSS) + '</small> &middot; <strong>Sie sparen ' + eur(activeSave) + '</strong>';
        } else if (isSlotCapped) {
          vpeSubEl.innerHTML = cartNotePrefix + 'Volle VPE (' + effQty + '&nbsp;St.), aber bereits 5 Rabattcodes mit höherer Ersparnis im Warenkorb aktiv.';
        } else if (isPartialNonVpe) {
          var nextCartons = fullCartons + 1;
          var nextEffQty = nextCartons * vpeQty;
          var diffToNext = nextEffQty - effQty;
          var nextSave = (vpeDiscCents * nextEffQty) / 100.0;
          vpeSubEl.innerHTML = cartNotePrefix + 'Ohne Rabatt &middot; Noch <strong>' + diffToNext + '&nbsp;St.</strong> bis <strong>' + nextEffQty + '&nbsp;St. (' + nextCartons + '&nbsp;VPE)</strong> &rarr; ' + eur(nextSave) + ' sparen';
        } else {
          var oneVpeSave = (vpeDiscCents * vpeQty) / 100.0;
          vpeSubEl.innerHTML = cartNotePrefix + 'Bei vollen VPE (' + vpeQty + '&nbsp;&middot;&nbsp;' + (vpeQty * 2) + '&nbsp;&middot;&nbsp;' + (vpeQty * 3) + '&nbsp;St.): <strong>' + eur(vpeUnitGross) + '/St.</strong> <small>statt ' + eur(UNIT_GROSS) + '</small> &middot; ' + eur(oneVpeSave) + ' je VPE sparen';
        }
      }
    }
    var mitSteuer = VAT > 1;
    gross.textContent = 'Zwischensumme für ' + qty.toLocaleString('de-DE') +
      ' Stück: ' + eur(sum) + (mitSteuer ? ' inkl. MwSt.' : ' ohne MwSt.');
    net.textContent = mitSteuer ? eur(sum / VAT) + ' exkl. MwSt.' : '';
  };

  document.addEventListener('lmm:cart-rendered', function () {
    syncInCartQtyFromDrawer();
    render();
  });

  if (vpePlusBtn) {
    vpePlusBtn.addEventListener('click', function () {
      var cur = parseStrictQty(input.value);
      var inCart = getInCartQty();
      var eff = inCart + cur;
      var nextEff = (Math.floor(eff / vpeQty) + 1) * vpeQty;
      var next = Math.max(1, nextEff - inCart);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  if (vpeMinusBtn) {
    vpeMinusBtn.addEventListener('click', function () {
      var cur = parseStrictQty(input.value);
      var inCart = getInCartQty();
      var eff = inCart + cur;
      var targetEff;
      if (eff % vpeQty !== 0) {
        targetEff = Math.floor(eff / vpeQty) * vpeQty;
      } else {
        targetEff = (Math.floor(eff / vpeQty) - 1) * vpeQty;
      }
      var next = (targetEff >= vpeQty && targetEff - inCart >= 1) ? (targetEff - inCart) : 1;
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* Theme-Stepper (lmm-pdp.js) dispatcht 'change' aufs Input; 'input' deckt
     direkte Eingabe ab. */
  ['input', 'change'].forEach(function (evt) {
    input.addEventListener(evt, render);
  });
  syncInCartQtyFromDrawer();
  render();
})();
